import { AuthSkyPlanes } from './AuthSkyPlanes';
import { AuthSkyStars } from './AuthSkyStars';

/** Auth split backdrop — mountain wallpaper, planes, and sky stars. */
export function AuthSplitDecor() {
  return (
    <div className="auth-split-decor" aria-hidden="true">
      <div className="auth-mountain-wallpaper auth-mountain-wallpaper--light" />
      <div className="auth-mountain-wallpaper auth-mountain-wallpaper--dark" />
      <AuthSkyPlanes />
      <AuthSkyStars />
    </div>
  );
}
